import React from 'react';

import AssetCardBody from './AssetCardBody/AssetCardBody';
import AssetCardContent from './AssetCardContent/AssetCardContent';

/**
 * @deprecated Will be removed after rhino migration.
*/

function AssetCard() {
  return (
    <AssetCardBody>
      <AssetCardContent />
    </AssetCardBody>
  );
}

export default AssetCard;
